import makeStyles from '@material-ui/core/styles/makeStyles';
import EmptySvg from '../assets/empty.svg';

type Props = {
  message: string;
};

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  message: {
    marginTop: 10,
  },
  emptyImage: {
    width: 300,
    height: 300,
  },
}));

function EmptyComponent({message}: Props) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        <div className={classes.col}>
          <img className={classes.emptyImage} src={EmptySvg} alt="Empty list" />
          <div className={classes.message}>{message}</div>
        </div>
      </div>
    </>
  );
}
export default EmptyComponent;
